import { ChevronDown, ChevronUp } from 'lucide-react';
import type { Dispatch, SetStateAction } from 'react';
import { Button } from '@/components/ui/button';

type Dir = 'desc' | 'asc';
type SortParameter = 'viewed_count' | 'last_viewed';
type Sort = `${SortParameter}:${Dir}`;

const SortButtons = ({ sort, setSort }: { sort: string; setSort: Dispatch<SetStateAction<Sort>> }) => {
  const [sortParameter, sortDirection] = sort.split(':');
  return (
    <>
      <Button
        variant={'outline'}
        className='flex'
        onClick={() => setSort(`viewed_count:${sortDirection === 'asc' ? 'desc' : 'asc'}`)}
      >
        Mest besökta
        {
          {
            viewed_count: {
              asc: (
                <span className='inline-flex rounded-full border p-px'>
                  <ChevronUp
                    strokeWidth={2}
                    size={10}
                  />
                </span>
              ),
              desc: (
                <span className='inline-flex rounded-full border p-px'>
                  <ChevronDown
                    strokeWidth={2}
                    size={10}
                  />
                </span>
              ),
            }[sortDirection],
          }[sortParameter]
        }
      </Button>
      <Button
        variant={'outline'}
        className='flex'
        onClick={() => setSort(`last_viewed:${sortDirection === 'asc' ? 'desc' : 'asc'}`)}
      >
        Senast besökta
        {
          {
            last_viewed: {
              asc: (
                <span className='inline-flex rounded-full border p-px'>
                  <ChevronUp
                    strokeWidth={2}
                    size={10}
                  />
                </span>
              ),
              desc: (
                <span className='inline-flex rounded-full border p-px'>
                  <ChevronDown
                    strokeWidth={2}
                    size={10}
                  />
                </span>
              ),
            }[sortDirection],
          }[sortParameter]
        }
      </Button>
    </>
  );
};

export { type Dir, type Sort, SortButtons, type SortParameter };
